import React, { Component } from 'react'
import { withNamespaces } from "react-i18next";
import MobileSidebar from '../../components/Sidebar/MobileSidebar';
import { Icon } from "@iconify/react";


class MobileHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
        return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    render() {
        const { t } = this.props;
        const img = this.imageImport(require.context("../../assets/images/home",false, /\.(png|jpe?g|svg|webp)$/));
        const mobImg = this.imageImport(require.context("../../assets/images/home/mobile",false, /\.(png|jpe?g|svg|webp)$/));
        const logo = this.imageImport(require.context("../../assets/images/", false, /\.(png|jpe?g|svg|webp)$/));
        const global = this.imageImport(require.context("../../assets/images/",false,/\.(png|jpe?g|svg|webp)$/));

        let imageLanguage = '';
        switch (this.props.currentUser.language_code) {
            case "zh-CN":
                imageLanguage = "-cn"
                break;
            // case "ms":
            //     imageLanguage = "-ms"
            //     break;
            default:
                imageLanguage = ""
                break;
        }

        return (
            <>
                <div className='position-fixed' style={{ width: "100%", top: "0%", zIndex: 99}}>
                    <MobileSidebar />
                    <img src={logo["x33-logo.png"]} alt="logo" width={160} style={{ position: "absolute", bottom: "20%", left: "42%"}}/>
                </div>

                <div className='position-relative'>
                    <img style={{ width: "100%"}} src={mobImg[`home-mobile-banner${imageLanguage}.webp`]} alt='home banner'/>

                    <div className='position-absolute text-center' style={{ bottom: "6%", width: "100%" }}>
                        <button className='btn btn-blue' type='button'>
                            {t('home.learn-now')}
                        </button>
                    </div>
                </div>

                <div className='home'>                        
                    <section className='section hero'>
                        <div className='m-container'>
                            <div className='position-relative light-blue-container-shadow mb-4'>
                                <img src={img['45-percent-com.webp']} alt='45% commission'/>
                                <div className='font-position'>
                                    <h3>{t('home.high-allocation')}</h3>
                                    <p>{t('home.earn-up')}</p>
                                    <h1 className='mt-3'>45%</h1>
                                    <p>{t('home.revenue-share')}</p>
                                </div>
                            </div>
                        
                            <div className='position-relative light-blue-container-shadow mb-4'>
                                <img src={img['zero-risk.webp']} alt='zero risk'/>                                
                                <div className='font-position right'>
                                    <h3>{t('home.zero-risk')}</h3>
                                    <h3>{t('home.zero-loss')}</h3>
                                    <p>{t('home.100-safe')}</p>                              
                                </div>
                            </div>

                            <div className='position-relative light-blue-container-shadow mb-4'>
                                <img src={img['join-us.webp']} alt='join us'/>     
                                <div className='font-position right mt-3'>
                                    <p>{t('home.become-our')}</p>                              
                                    <h3>{t('home.affiliate')}</h3>                                    
                                </div>                           
                            </div>    

                            <div className='text-center'>
                                <button className='btn btn-blue mt-2'>{t('home.learn-now')}</button>                                                                                           
                            </div>
                        </div>
                    </section>

                    <section className='section earnings'>
                        <div className='d-flex flex-column justify-content-between text-center'>                                
                            <div>
                                <h3>{t('home.company-net-profit')}</h3>
                                <h2>MYR 50,000</h2>
                            </div>

                            <Icon icon="fluent-mdl2:status-circle-error-x"/>

                            <div>
                                <h3>{t('home.commission-rate')}</h3>
                                <h2>45%</h2>
                            </div>

                            <Icon icon="ri:equal-line"/>

                            <div>
                                <h3>{t('home.earnings')}</h3>
                                <h2>MYR 22,500</h2>
                            </div>
                        </div>                                                                                                             

                        <img className='mt-1' src={mobImg['earnings-mobile-bg.webp']} alt='earnings background'/>                                                         
                        <p>{t('home.join-x33-affiliate')}</p>
                    </section>
                
                    <section className='section stats'>
                        <div className='m-container'>
                            <div className='light-blue-container-shadow'>
                                <div className='position-relative'>
                                    <img src={mobImg['home-mobile-container.webp']} alt='home container'/>

                                    <div className='position-absolute' style={{ top: "5%", width: "90%", left: "5%" }}>
                                        <div className='stats-content'>
                                            <img className='no-shadow' src={img['global.svg']} alt='global'/>
                                            <div className='d-flex'>
                                                <p>20K</p>
                                                <Icon icon="tdesign:plus"/>
                                            </div>
                                            <h3>{t('home.join-affiliate-agent')}</h3>
                                            <span>{t('home.global')}</span>
                                        </div>
                                        <div className='divider'></div>
                                        <div className='stats-content'>
                                            <img className='no-shadow' src={img['commission.svg']} alt='commission'/>
                                            <div className='d-flex'>
                                                <p>13K</p>
                                                <Icon icon="tdesign:plus"/>
                                            </div>
                                            <h3>{t('home.join-affiliate-agent')}</h3>
                                            <span>{t('home.earn-daily-commission')}</span>
                                        </div>
                                        <div className='divider'></div>
                                        <div className='stats-content'>
                                            <img className='no-shadow' src={img['country.svg']} alt='country'/>
                                            <div className='d-flex'>
                                                <p>24</p>
                                                <Icon icon="tdesign:plus"/>
                                            </div>
                                            <h3>{t('home.country')}</h3>
                                            <span>{t('home.affiliate-country')}</span>
                                        </div>
                                        <div className='divider'></div>
                                        <div className='stats-content'>
                                            <img className='no-shadow' src={img['daily-commission.svg']} alt='daily-commission'/>
                                            <div className='d-flex'>
                                                <p>10M</p>
                                                <Icon icon="tdesign:plus"/>
                                            </div>
                                            <h3>USD</h3>
                                            <span>{t('home.daily-payout')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>                
                </div>                            

                <div className='join-us'>
                    <div className='d-flex flex-column align-items-center text-center justify-content-center m-container'>
                        <h2>{t('global.join-xingbo')},</h2>
                        <h2>{t('global.waiting-for')}</h2>
                        <h1>{t('global.we-promise')}</h1>
                        <button className='btn btn-blue my-4'>{t('page-header.join-now')}</button>                            
                        <img className='main-asset' src={global['brand-ambassador.webp']} alt='brand ambassador'/>  
                    </div>
                </div>
            </>
        )
    }
}

export default (withNamespaces("translation")(MobileHome));

